import * as React from 'react';
import { MessageBar, MessageBarType, Stack } from '@fluentui/react';

interface ErrorBoundaryProps {
  featureName: string;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error(`[ErrorBoundary] ${this.props.featureName} crashed:`, error, errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <Stack tokens={{ padding: 24, childrenGap: 12 }}>
          <MessageBar messageBarType={MessageBarType.error}>
            Something went wrong in {this.props.featureName}. Please try refreshing the page.
          </MessageBar>
        </Stack>
      );
    }
    return this.props.children;
  }
}
